import Cookies from 'js-cookie';
import { createFocusTrap } from 'focus-trap';

/**
 * returns an object containing dom nodes needed for operation
 *
 * @returns all relevant dom nodes
 */
const getModalRefs = () => {
  return {
    body: document.querySelector('body'),
    modalWrapper: document.querySelector('#avm-modal_wrapper'),
    enterBtn: document.querySelector('#btn-avm_enter'),
    exitBtn: document.querySelector('#btn-avm_exit'),
  };
};

/**
 * sets up the age modal:
 * only shows it if the cookie ageCookie is not set to true
 *
 * @returns undefined
 */
export const setupAgeModal = () => {
  const ageCookie = Cookies.get('ageCookie');
  console.log(`age cookie is ${ageCookie}`);

  if (ageCookie != 'true') {
    const { body, modalWrapper, enterBtn, exitBtn } = getModalRefs();
    const focusTrap = createFocusTrap(modalWrapper);
    showModal(body, modalWrapper, focusTrap);

    enterBtn.addEventListener(
      'click',
      () => {
        Cookies.set('ageCookie', true);
        hideModal(body, modalWrapper, focusTrap);
      },
      { once: true }
    );

    exitBtn.addEventListener(
      'click',
      () => {
        window.location.href = '/';
      },
      { once: true }
    );
  }
};

/**
 * shows the age verification modal
 *
 * @param {domNode} body: dom node that references the website body
 * @param {domNode} modalWrapper: dom node that references modalWrapper
 * @param {focus-trap} focusTrap: focus trap that was created
 */
const showModal = (body, modalWrapper, focusTrap) => {
  window.scrollTo(0, 0);
  body.classList.add('dialog__no-scroll');
  modalWrapper.classList.remove('hidden');
  focusTrap.activate();
};

/**
 * hides the age verification modal
 *
 * @param {domNode} body: dom node that references the website body
 * @param {domNode} modalWrapper: dom node that references modalWrapper
 * @param {focus-trap} focusTrap: focus trap that was created
 */
const hideModal = (body, modalWrapper, focusTrap) => {
  body.classList.remove('dialog__no-scroll');
  modalWrapper.classList.add('hidden');
  focusTrap.deactivate();
};
